export const ADD_HYDROGEN_MEASUREMENT_DATA = 'ADD_HYDROGEN_MEASUREMENT_DATA';
export const CONFIRM_HYDROGEN_MEASUREMENT_DATA =
  'CONFIRM_HYDROGEN_MEASUREMENT_DATA';
export const FETCH_HYDROGEN_MEASUREMENT_DATA =
  'FETCH_HYDROGEN_MEASUREMENT_DATA';
export const FETCH_PREVIOUS_HYDROGEN_MEASUREMENT_SURPLUS =
  'FETCH_PREVIOUS_HYDROGEN_MEASUREMENT_SURPLUS';
export const FETCH_IS_GOS_ISSUED = 'FETCH_IS_GOS_ISSUED';
